import script from "./Tree.vue?vue&type=script&setup=true&lang=js"
export * from "./Tree.vue?vue&type=script&setup=true&lang=js"

export default script